import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import {
  TCHModelConfigurationButtonMod,
  TCHModelConfigurationFields,
  TCHModelConfigurationInnerComponent,
  TCHModelConfigurationParams,
  TCHModelConfigurationProps,
} from '../types/productModelConfigurations.types';

import { StringField } from '../../../types/types';
import { BACKGROUND_COLOR_MAP } from '../../../constants/background-color.constants';
import { appendRootToRichTextInternalLinks } from '../../../utils/appendRootToRichTextInternalLinks.utils';

export class CHModelConfigurationModel {
  private readonly fields: TCHModelConfigurationFields;
  private readonly params?: TCHModelConfigurationParams;
  private readonly rendering?: ComponentRendering;

  constructor(props: TCHModelConfigurationProps) {
    this.fields = props?.fields || null;
    this.rendering = props?.rendering;
    this.params = props?.params;
  }

  get backgroundColor(): string | undefined {
    return BACKGROUND_COLOR_MAP.get(this.params?.backgroundColor || '');
  }

  get thumbnailEE(): string {
    return this.fields?.itemData?.thumbnail || '';
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get title(): StringField {
    return { value: this.fields?.apiData?.title };
  }

  get eyebrow(): StringField {
    return { value: this.fields?.apiData?.eyebrow };
  }

  get description(): StringField {
    return { value: appendRootToRichTextInternalLinks(this.fields?.apiData?.description) };
  }

  get button1(): TCHModelConfigurationButtonMod {
    const { url: href, label, target } = this.fields?.apiData?.button1 ?? { href: '', label: '', target: '' };
    return { href, label, target };
  }

  get button2(): TCHModelConfigurationButtonMod {
    const { url: href, label, target } = this.fields?.apiData?.button2 ?? { href: '', label: '', target: '' };
    return { href, label, target };
  }

  get innerComponents(): TCHModelConfigurationInnerComponent[] {
    return this.fields?.apiData?.innerComponents || [];
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
